<div class="f8-wrap">

  <button class="f8-close" (click)="onCancel()" [disabled]="isLoading">
    <span class="material-icons">close</span>
  </button>

  <div class="f8-head">
    <div class="f8-icon-ring">
      <span class="material-icons">link</span>
    </div>
    <h3 class="f8-title">Lier le paiement F8</h3>
    <p class="f8-subtitle">Correspondance exacte avec la commande</p>
  </div>

  <div class="f8-amount-pill">
    <span class="f8-amount-num">{{ data.amount | number:'1.2-2' }} DH</span>
    <span class="f8-amount-tag">
      <span class="material-icons">check</span>
      Total confirmé
    </span>
  </div>

  <div class="f8-details">
    <div class="f8-detail-row">
      <span class="f8-dk">Commande</span>
      <span class="f8-dv">{{ data.order.id ? "#" + data.order.id : "Nouvelle commande" }}</span>
    </div>
    <div class="f8-detail-row" *ngIf="clientName">
      <span class="f8-dk">Client</span>
      <span class="f8-dv">{{ clientName }}</span>
    </div>
    <div class="f8-detail-row">
      <span class="f8-dk">Total</span>
      <span class="f8-dv">{{ effectiveTotal | number:'1.2-2' }} DH</span>
    </div>
  </div>

  <p class="f8-note">La commande sera enregistrée comme <strong>payée</strong> et liée à ce F8.</p>

  <div class="f8-btns">
    <button class="f8-btn-normal" (click)="onRefuse()" [disabled]="isLoading">F8 normal</button>
    <button class="f8-btn-link" (click)="onConfirm()" [disabled]="isLoading">
      <span class="f8-spinner" *ngIf="isLoading"></span>
      <span class="material-icons" *ngIf="!isLoading">link</span>
      {{ isLoading ? 'Création…' : 'Lier' }}
    </button>
  </div>

</div>